"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./loader.css");
const Loader = ({ loaderColor = "DodgerBlue", className = "", spinnerItemClassName = "", fullWidth }) => {
    const inlineColor = loaderColor.length > 0 ? { borderTopColor: loaderColor } : {};
    const wrapperClass = fullWidth ? "" : "loader--normal";
    return (react_1.default.createElement("div", { className: `loader ${wrapperClass} ${className}` },
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: spinnerItemClassName, style: inlineColor }),
            react_1.default.createElement("div", { className: spinnerItemClassName, style: inlineColor }),
            react_1.default.createElement("div", { className: spinnerItemClassName, style: inlineColor }),
            react_1.default.createElement("div", { className: spinnerItemClassName, style: inlineColor }))));
};
exports.default = Loader;
//# sourceMappingURL=loader.js.map